export default __webpack_public_path__ + "img/0af1544d6a386cdd88135777be0c684b.svg";